import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const HerculesPaasPage = lazy(() => import('../pages/producto/hercules-paas/page'));
const PmsPage = lazy(() => import('../pages/producto/pms/page'));
const EcrCloudPage = lazy(() => import('../pages/producto/ecr-cloud/page'));
const DinvoiPage = lazy(() => import('../pages/producto/dinvoi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/producto/hercules-paas",
    element: <HerculesPaasPage />,
  },
  {
    path: "/producto/pms",
    element: <PmsPage />,
  },
  {
    path: "/producto/ecr-cloud",
    element: <EcrCloudPage />,
  },
  {
    path: "/producto/dinvoi",
    element: <DinvoiPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;